<script setup>
import { useTemplateRef } from 'vue'

import AppDivider from '@/components/ui/AppDivider'

defineOptions({
  name: 'CheckinLayout'
})

defineProps({
  divied: {
    type: Boolean
  }
})

const layoutReference = useTemplateRef('layout-reference')

const scrollIntoView = () => {
  if (layoutReference.value) {
    layoutReference.value.scrollIntoView({
      block: 'end'
    })
  }
}

defineExpose({
  scrollIntoView
})
</script>

<template>
  <div ref="layout-reference" class="cl-Layout">
    <div v-if="$slots.author" class="cl-Layout_Author">
      <slot name="author" />
    </div>
    <AppDivider
      v-if="divied"
      class="cl-Layout_Divider"
      no-margin
      style="--divider-color: var(--grey-3-next)"
    />
    <div class="cl-Layout_Body">
      <slot name="body" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cl-Layout {
  //display: grid;
  display: flex;
  flex-direction: column;
  direction: ltr;
  // grid-template-columns: var(--fields-padding-left) 1fr;
  row-gap: var(--checkin-layout-row-gap, 12px);
  max-width: calc(var(--checkin-field-width, 100%) + var(--fields-padding-left, 0));
}

.cl-Layout_Author {
  // grid-column: span 2;
  max-width: 100%;
  overflow: hidden;
  padding: var(--checkin-layout-author-padding, 0);
}

.cl-Layout_Body {
  // grid-column: 2 / 3;
  padding: var(--checkin-layout-body-padding, 0 0 0 var(--fields-padding-left, 0));
  display: flex;
  flex-direction: column;
  gap: var(--checkin-layout-body-gap);
}
</style>
